import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/maintain/plan`,
    name: 'MAINTAIN_PLAN_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
